<template>
    <div class="preview-sidebar">
      <div class="preview-sidebar__pillar-logo">
        <img src="/img/pillar-logo.png" alt="pillar logo">
      </div>
      <div class="preview-sidebar__text_wrap">
        <p class="text-primary">{{ $t('early_preview.finish_setting_up_title') }}</p>
        <p class="text-secondary">{{ $t('early_preview.finish_setting_up_description') }}</p>
      </div>
      <div class="preview-sidebar__button_wrap">
        <button class="button button-l button-primary" @click.prevent="continueEditing()">{{ $t('early_preview.continue_editing') }}</button>
      </div>
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        props: {
          route: {
            type: String,
            default: ''
          }
        },
        methods: {
          continueEditing() {
            window.location.href = this.route;
          }
        }
    }
</script>